import React from "react";
import { Link } from "react-router-dom";
import logoImg from "../../../assets/images/logo.svg";
import { useCurrentLanguage } from "../../../misc";

/**
 *
 * AppHeader - common component use for show header in layout.
 *
 */

const AppHeader = () => {
  const settings = useCurrentLanguage();

  return (
    <div className="header">
      <div className="logo_container">
        <Link to="/">
          <div className="logo_img">
            <img src={logoImg} alt="main logo" />
          </div>
        </Link>
        <Link to="/" style={{ textDecoration: "none" }}>
          <h4>{settings.staticString.akilliBahis}</h4>
        </Link>
      </div>
    </div>
  );
};

export default AppHeader;
